var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/play-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "play-circle_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.96 2.6665C8.60004 2.6665 2.62671 8.63984 2.62671 15.9998C2.62671 23.3598 8.60004 29.3332 15.96 29.3332C23.32 29.3332 29.2934 23.3598 29.2934 15.9998C29.2934 8.63984 23.3334 2.6665 15.96 2.6665ZM19.96 18.9732L16.0934 21.1998C15.6134 21.4798 15.08 21.6132 14.56 21.6132C14.0267 21.6132 13.5067 21.4798 13.0267 21.1998C12.0667 20.6398 11.4934 19.6532 11.4934 18.5332V14.0665C11.4934 12.9598 12.0667 11.9598 13.0267 11.3998C13.9867 10.8398 15.1334 10.8398 16.1067 11.3998L19.9734 13.6265C20.9334 14.1865 21.5067 15.1732 21.5067 16.2932C21.5067 17.4132 20.9334 18.4132 19.96 18.9732Z",
    fill: "white"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayCircle);
export default __webpack_public_path__ + "static/media/play-circle.562bba549c608d58b5dc533af015fbd8.svg";
export { ForwardRef as ReactComponent };